/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useStockStore = defineStore("stock", {
  actions: {
    async summaryStockFetch(payload) {
      const body = {
        groupUid: payload.groupUid,
        shopUid: payload.shopUid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/stock/summary";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async stockListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          catCode: payload.catCode, // all under
          locCode: payload.locCode, // all under
          pawnValueOperator: payload.pawnValueOperator, // EQUAL, MORE_THAN, LESS_THAN, BETWEEN
          pawnValue: payload.pawnValue, // collateral pawnValue
          toPawnValue: payload.toPawnValue, // collateral pawnValue (only use when pawnValueOperator = BETWEEN)
          durationOperator: payload.durationOperator, // EQUAL, MORE_THAN, LESS_THAN, BETWEEN
          duration: payload.duration,
          toDuration: payload.toDuration, // (only use when durationOperator = BETWEEN)
          cusUid: payload.cusUid,
          tkRefNumber: payload.tkRefNumber,
          stockNumber: payload.stockNumber,
          status: payload.status, // ACTIVE, FREEZE
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-rpt-svc/stock/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async summaryStockDateFetch(payload) {
      const body = {
        groupUid: payload.groupUid,
        shopUid: payload.shopUid,
        date: payload.date,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/stock/summary/date";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
